import { IconButton } from '@eventbrite/eds-icon-button';
import { CurrentLocation } from '@eventbrite/eds-iconography';
import { InteractiveMap } from '@eventbrite/eds-interactive-map';
import { FormattedEvent } from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import BBoxSearchButton from './BBoxSearchButton';
import {
    INITIAL_MAP_BOUNDS_CHANGE_COUNT,
    SEARCH_MAP_OPTIONS,
} from './constants';
import withSearchMapBase from './SearchMapBase';

const MAP_TYPE_LOCAL = 'local';

interface SearchMapProps {
    events?: FormattedEvent[];
    height?: number | string;
    width?: number | string;
    countryCode?: string;
    googleMapLanguage?: string;
    latitude?: number;
    longitude?: number;
    searchByBBox?: Function;
    setShouldScroll?: Function;
    onSearchByBounds: Function;
    onClickOutsideMapMarker: Function;
    markers?: object[];
    propsForInteractiveMap: {
        height?: number | string;
        width?: number | string;
        language?: string;
        region?: string;
        center: {
            lat?: number;
            lng?: number;
        };
        zoom?: number;
        onChange?: Function;
        onGoogleApiLoaded?: Function;
    };
    mapBoundsChangeCount: number;
    tooltipSelectedEventsIds?: string[];
    onSaveEvent?: Function;
    viewEventMapView?: Function;
    isAuthenticated?: boolean;
    isFixed?: boolean;
    markerRef?: any;
    googleMapsApiKey?: string;
    setMapPinHoverTarget: Function;
    setMapPinClickTarget: Function;
    domain: string;
    isUsingCurrentLocation: boolean;
    handleUseCurrentLocation: Function;
    shouldMountMap: boolean;
    shouldShowMap: boolean;
}

class _SearchMap extends React.PureComponent<SearchMapProps> {
    render() {
        const {
            mapBoundsChangeCount,
            onSearchByBounds,
            markers,
            propsForInteractiveMap,
            googleMapsApiKey,
            isUsingCurrentLocation,
            handleUseCurrentLocation,
            shouldMountMap,
            shouldShowMap,
        } = this.props;

        const bboxSearchButtonStyle = {
            margin: '16px 0',
            right: '50%',
            transform: 'translateX(50%)',
        };

        const searchMapClasses = classNames('search-map', {
            'search-map__hide': !shouldShowMap,
        });

        return (
            <>
                <div className={searchMapClasses}>
                    {mapBoundsChangeCount > INITIAL_MAP_BOUNDS_CHANGE_COUNT && (
                        <BBoxSearchButton
                            style={bboxSearchButtonStyle}
                            onClick={onSearchByBounds}
                        />
                    )}
                    <div className="user-location-button">
                        <IconButton
                            style={isUsingCurrentLocation ? 'link' : 'neutral'}
                            iconType={<CurrentLocation />}
                            onClick={handleUseCurrentLocation}
                            title={
                                isUsingCurrentLocation
                                    ? gettext('Using current location')
                                    : gettext('Use my current location')
                            }
                        />
                    </div>
                    {shouldMountMap ? (
                        <InteractiveMap
                            {...propsForInteractiveMap}
                            googleMapsApiKey={googleMapsApiKey}
                            googleMapsLibraries={['places']}
                            mapType={MAP_TYPE_LOCAL}
                            options={SEARCH_MAP_OPTIONS}
                        >
                            {markers}
                        </InteractiveMap>
                    ) : null}
                </div>
            </>
        );
    }
}

export const SearchMap = withSearchMapBase(_SearchMap);
